export const formatTypeFilterCountDisplay = count => {
    const numericCount = Number(count);

    if (!Number.isFinite(numericCount) || numericCount <= 0) {
        return '0';
    }

    if (numericCount >= 1000) {
        return '1000+';
    }

    return String(Math.trunc(numericCount));
};
